import { Component } from '@angular/core';
import { LoadingController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { RodeoService } from '../../../../services/rodeo.service';
import { Rodeo } from '../../../../model/rodeo';
import { AlertMessager } from '../../../../lib/alertMessager';
import { StockGroup } from '../../../../model/stock-group';
import { Livestock } from '../../../../model/livestock';
import { StockService } from '../../../../services/stock.service';

@Component({
    selector: 'draw-prompt',
    templateUrl: 'draw-prompt.html'
})
export class DrawPromptPage {
    rodeo: Rodeo;
    drawSelection: any;
    bulkFile: any;
    livestock: any;

    drawConfig: any = { minSpread: 23, maxSpread: 50, startNumber: 1, stockGroups: [] };

    roundArray: any[];

    constructor(navParams: NavParams, private viewController: ViewController, private alert: AlertMessager, private stockService: StockService,
        private rodeoService: RodeoService, private loadingControl: LoadingController, private toast: ToastController) {
        this.rodeo = navParams.get('rodeo');
        this.drawSelection = navParams.get('drawSelection');
        this.drawConfig.rodeoId = this.rodeo.id;

        if (this.drawSelection)
            this.drawConfig.rodeoEventId = this.drawSelection.id;
        else
            this.drawSelection = 'All';
    }

    matchDisciplineType(a: string, b: string) {
        return a == b;
    }

    matchDisciplines(a: string, b: string) {
        return a == b;
    }

    bulkUploadFileChanged($event): void {
        this.bulkFile = $event.target.files[0];
        this.livestock = [];

        var reader = new FileReader();

        reader.onload = (e) => {
            var text = (e.target as any).result;
            var delimiter = ",";

            const rows = (text as string).split("\n");

            rows.forEach((row) => {
                var stockComponents = row.split(delimiter);
                this.livestock.push(new Livestock(stockComponents[0], stockComponents.length > 1 ? stockComponents[1] : null));
            });
        }

        reader.readAsText(this.bulkFile);
    }

    updateDrawSelection() {
        this.roundArray = [];

        if (this.drawSelection != 'All') {
            this.drawConfig.startNumber = this.drawSelection.schedules.flatMap(x => x.runs).length == 0 ? 1 : Math.max(...this.drawSelection.schedules.flatMap(x => x.runs).map(x => x.number));
            this.drawConfig.rodeoEventId = this.drawSelection.id;

            for (let i = 1; i <= this.drawSelection.rounds + (this.drawSelection.shortGo ? 1 : 0); i++) {
                this.roundArray.push(i);
            }
        } else {
            this.drawConfig.startNumber = 1;
            this.drawConfig.rodeoEventId = null;
        }
    }

    async draw() {
        let loading = this.loadingControl.create({
            content: 'Drawing...',
        });

        loading.present();

        if (this.drawConfig.drawStockOnly && this.livestock && this.livestock.length > 0) {
            let newStockGroup = new StockGroup();
            newStockGroup.stockContractorId = 1;
            newStockGroup.name = this.drawSelection.displayName + ' Draw';
            newStockGroup.livestock = this.livestock;

            try {
                let data = await this.stockService.addStockGroup(newStockGroup, this.rodeo.id)

                this.drawConfig.stockGroups = [data as StockGroup];
                this.rodeo.stockGroups.push(data as StockGroup);
            }
            catch (err) {
                loading.dismiss();
                this.alert.showError("Stock Group Add Error", err);
            }
        }

        this.rodeoService.draw(this.drawConfig)
            .then(data => {
                loading.dismiss();

                this.toast.create({
                    message: this.drawSelection == 'All' ? 'Rodeo' : this.drawSelection.displayName + " drawn!",
                    duration: 3000,
                    position: 'middle',
                }).present();

                this.viewController.dismiss({ rodeoDrawn: this.drawSelection == 'All', rodeoEventDrawn: this.drawSelection });
            }, error => {
                loading.dismiss();
                this.alert.showError("Draw Error", error);
            });
    }

    cancel() {
        this.viewController.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/draw/draw-prompt.ts